import React from "react";
import { useSelector } from "react-redux";
import PulseLoader from "react-spinners/PulseLoader";
import CurrencyFormat from 'react-currency-format';
import {
    Card,
    CardBody,
    CardTitle
} from "reactstrap";

const LatestTransaction = () => {
    const { data, loading } = useSelector(state => ({
        data: state.Dashboard.data,
        loading: state.Dashboard.loading,
    }));

    return <Card>
        <CardBody style={{ maxHeight: '576px', minHeight: '200px' }}>
            <CardTitle>Latest Transaction</CardTitle>
            <div className="table-responsive react-table mt-2">
                <table className="table table align-middle table-nowrap table-check">
                    <thead className="table-light table-nowrap">
                        <tr>
                            <th className="text-center">Date</th>
                            <th className="text-center">Remarks</th>
                            <th className="text-center">Account</th>
                            <th className="text-center">Type</th>
                            <th className="text-center">Nominal</th>
                            <th className="text-center">Adjustment</th>
                            <th className="text-center">Fiscal</th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            data && data.latestTrans ? data.latestTrans.map((trans, idx) => {
                                return <tr key={'ltTrans' + idx}>
                                    <td className="text-center">{trans.dateShort}</td>
                                    <td>{trans.remarks}</td>
                                    <td>{trans.account?.code} - {trans.account?.name}</td>
                                    <td className="text-center">{trans.type}</td>
                                    <td className="text-end">
                                        <CurrencyFormat value={trans.nominal ?? 0} thousandSeparator={'.'} decimalSeparator={','} decimalScale={2}
                                            displayType={'text'} />
                                    </td>
                                    <td className="text-center">
                                        {trans.adjustment && <i className="fa fa-check text-success"></i>}
                                        {!trans.adjustment && <i className="fa fa-times text-danger"></i>}
                                    </td>
                                    <td className="text-center">
                                        {trans.fiscal && <i className="fa fa-check text-success"></i>}
                                        {!trans.fiscal && <i className="fa fa-times text-danger"></i>}
                                    </td>
                                </tr>
                            }) :
                                <tr>
                                    <td className="text-center pt-4 border-0" colSpan={7}>
                                        <center><PulseLoader loading={loading} color={'#FFF'} size={8} className="align-self-center" /></center>
                                        {!loading && <h6>No data available.</h6>}
                                    </td>
                                </tr>
                        }
                    </tbody>
                </table>
            </div>
        </CardBody>
    </Card>
}

export { LatestTransaction }